const review = {
    state: {
        reviewInfo: {},
        isList: true
    },
    mutations: {
        setReviewInfo(state,payload) {
            state.reviewInfo = payload
        },
        setIsList(state,payload) {
            state.isList = payload
        }
    }
}

export default review
